module.exports = __webpack_public_path__ + "img/default.1e1a303a.svg";